/**
 * Bilspektrum's own FPV films, cut into short hero loops (see public/assets/videos/bilspektrum).
 * Each clip has a 16:9 desktop file and a 9:16 centre-cropped phone file.
 *
 * Source films (not in the repo): Bilspektrum_Showroom_1080p.mp4 and
 * Bulspektrum_Verkstad_1080p.mp4. To recut: ffmpeg -ss <start> -t <length>,
 * 1280x720 for desktop, crop=608:1080 → 540x960 for phone, H.264 CRF 27, no audio.
 */

export type VideoClip = {
  desktop: string;
  mobile: string;
  poster: string;
  posterMobile: string;
};

const clip = (name: string): VideoClip => {
  const base = `/assets/videos/bilspektrum/${name}`;
  return {
    desktop: `${base}-desktop.mp4`,
    mobile: `${base}-mobile.mp4`,
    poster: `${base}-poster.jpg`,
    posterMobile: `${base}-poster-mobile.jpg`,
  };
};

export const BILSPEKTRUM_CLIPS = {
  /** Through the workshop (Verkstad 0:47–0:59). Not used: Oscar wants the Bilspektrum film instead. */
  verkstad: clip("verkstad"),
  /** Into the new-car showroom past the lounge and the podium (Verkstad 0:19–0:30). About page. */
  nybilshall: clip("nybilshall"),
} as const;

/**
 * Homepage film, indoors only (no snow on cars – client requirement):
 * in through the entrance → reception (Showroom 0:17–0:31) → showroom (0:41–0:52),
 * 0.6 s cross-fade. All outdoor footage in the source films shows snow, so it's left out.
 * Also on /verkstad and in the homepage workshop band (client request, no workshop footage).
 */
export const BILSPEKTRUM_FILM: VideoClip = clip("bilspektrum");
